import React, { useState, useMemo, useEffect, useRef } from "react";
import {
	MDBPopover,
	MDBPopoverBody,
	MDBBtn,
} from "mdbreact";
import { useSelector } from "react-redux";
import useFetch from "../CustomHooks/useFetch";
import Loader from "../childdetail/ChildDashboard/DevelopmentDasboard/charts/Loader";
import SnackBar from "../../GeneralComponents/SnackBar";
import PaymentConfirmationModal from "./PaymentConfirmationModal";
import InfoIcon from "@material-ui/icons/Info";
import SearchIcon from "@material-ui/icons/Search";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import FileDownloadIcon from "@material-ui/icons/GetApp";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PeopleIcon from "@material-ui/icons/People";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core";
//!importing card stripe
import CardStripe from "./CardStripe.jsx";
import { useTranslation } from "react-i18next";
import PageShell from "../ui/PageShell";
import DataTable from "../ui/DataTable";
import EmptyState from "../ui/EmptyState";
import styles from "./PayRoll.module.scss";

const PAYMENT_MULTIPLIER = 100;

const useStyles = makeStyles({
	button: {
		backgroundColor: "transparent!important",
		boxShadow: "none!important",
		padding: "0",
		margin: "0",
	},
});

const getInitials = (firstName = "", lastName = "") => {
	const first = firstName ? firstName.charAt(0) : "";
	const last = lastName ? lastName.charAt(0) : "";
	return `${first}${last}`.toUpperCase() || "S";
};

const PayRoll = (props) => {
	const { t } = useTranslation();
	const [date, setDate] = useState(
		new Date().toLocaleDateString("en-IN", {
			day: "numeric",
			month: "long",
			year: "numeric",
		})
	);
	const accessibilityData = useSelector((state) => state).accessibility;

	const [totalData, setTotalData] = useState([]);
	const classes = useStyles();
	const [filteredData, setFilteredData] = useState([]);
	const [isChecked, setIsChecked] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [direction, setDirection] = useState([
		false,
		null,
		null,
		null,
		null,
		null,
		null,
		null,
	]);

	const currency = useSelector((state) => state.currency);
	const keywords = useSelector((state) => state.config.keywords);

	const currentMonth = useMemo(() => date.split(" ").slice(1).join(" "), [
		date,
	]);
	const [getPayRollBody, setGetPayRollBody] = useState(() =>
		JSON.stringify({
			month: currentMonth,
		})
	);
	//const countryData = useFetch({ url: `/daycareDetails` });
	const country = useSelector((state) => state.country.country);
	//const [country, setCountry] = useState("");
	useEffect(() => {
		setIsLoading(true);
		setError(null);
		setGetPayRollBody(
			JSON.stringify({
				month: currentMonth,
			})
		);
	}, [currentMonth]);

	const [payBody, setPayBody] = useState(null);
	const [emailBody, setEmailBody] = useState(null);
	const [downloadBody, setDownloadBody] = useState(null);
	const snackBarRef = useRef();
	// const [anchorEl, setAnchorEl] = useState(null);
	// const open = Boolean(anchorEl);
	const [snackBarContent, setSnackBarContent] = useState("");
	const [modalOpen, setModalOpen] = useState(false);
	const [month, setMonth] = useState(null);
	const [payableAmount, setPayableAmount] = useState(0);
	const [selectedStaff, setSelectedStaff] = useState(0);
	const [paymentSuccess, setPaymentSuccess] = useState(false);

	const [totalGrossSum, setTotalGrossSum] = useState(null);
	const [totalDeductionSum, setTotalDeductionSum] = useState(null);
	const [totalNetSum, setTotalNetSum] = useState(null);
	const [totalPaid, setTotalPaid] = useState(0);
	const [totalEntries, setTotalEntries] = useState(0);

	const [adhocDataBody, setAdHocDataBody] = useState(null);

	const payResponse = useFetch({
		url: "/daycare/salary/paySalary",
		body: payBody,
		method: "PATCH",
		accessibility: accessibilityData["Payroll"],
	});
	const sendEmailResponse = useFetch({
		url: "/create/salarySlip/sendEmail",
		body: emailBody,
		method: "POST",
		accessibility: accessibilityData["Payroll"],
	});
	const downloadPayslipResponse = useFetch({
		url: "/create/salarySlip/downloadPayslip",
		body: downloadBody,
		method: "POST",
		accessibility: accessibilityData["Payroll"],
	});

	const getPayRoll = useFetch({
		url: "/daycare/salary",
		body: getPayRollBody,
		method: "POST",
	});

	//!this handles generating AdHoc Data
	const generateAdHocData = useFetch({
		url: "/daycare/generate/payroll",
		body: adhocDataBody,
		method: "POST",
		accessibility: accessibilityData["Payroll"],
	});

	const [response, setResponse] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		console.log("salary error", getPayRoll.error);
		if (!getPayRoll.isLoading && getPayRoll.error) {
			setError(getPayRoll.error);
			setTotalPaid(0);
		}
	}, [getPayRoll.error, getPayRoll.isLoading]);
	useEffect(() => {
		setResponse(getPayRoll.response);
		if (getPayRoll.response) {
			setError(null);
		}
		setIsLoading(getPayRoll.isLoading);
	}, [getPayRoll.response, getPayRoll.isLoading]);

	useEffect(() => {
		if (response) {
			if (response.salaries.length > 0) {
				setError(null);
				handleSalaryResponse(response);
			}
		}
	}, [response]);

	const handleGenerateAdHocData = () => {
		setGetPayRollBody(null);
		setAdHocDataBody(
			JSON.stringify({
				month: currentMonth,
			})
		);
	};

	useEffect(() => {
		const body = generateAdHocData.response;
		setIsLoading(generateAdHocData.isLoading);
		if (body) {
			const response = body;
			if (response) {
				setSnackBarContent(t("Payroll successfully generated"));
				snackBarRef.current.openSnackBar();
				setResponse(response);
				setAdHocDataBody(null);
			}
		}
	}, [
		generateAdHocData.response,
		generateAdHocData.isLoading,
		generateAdHocData.error,
	]);

	const changeDate = (direction) => {
		const newDate = new Date(date);
		newDate.setMonth(newDate.getMonth() + direction);
		setDate(
			newDate.toLocaleDateString("en-IN", {
				day: "numeric",
				month: "long",
				year: "numeric",
			})
		);
		setIsDisabled(false);
	};

	const searchTextHandler = (text) =>
		setFilteredData(totalData.filter((ele) => ele.name.includes(text)));

	useEffect(() => {
		let gross = 0,
			deductions = 0,
			netPay = 0,
			paid = 0,
			currencySymbol = currency[0] + " ";
		if (filteredData.length >= 0) {
			filteredData.forEach((ele) => {
				gross += ele.grossNum;
				deductions += ele.totalDeductionsNum;
				netPay += ele.netPayNum;
				if (ele.status === "Paid") paid++;
			});
			setTotalGrossSum(`${currencySymbol}${gross.toLocaleString()}`);
			setTotalDeductionSum(`${currencySymbol}${deductions.toLocaleString()}`);
			setTotalNetSum(`${currencySymbol}${netPay.toLocaleString()}`);
			setTotalPaid(paid);
			setTotalEntries(filteredData.length);
			console.log(
				"gross things",
				gross,
				deductions,
				netPay,
				paid,
				filteredData.length
			);
		}
	}, [filteredData]);

	const handleSalaryResponse = (response) => {
		const data = [];
		let gross = 0,
			deductions = 0,
			netPay = 0,
			paid = 0,
			totalEntries = 0;
		const currencySymbol = currency[0] + " ";

		response.salaries.forEach((ele) => {
			(gross += parseFloat(ele.grossEarning)),
				(deductions += parseFloat(ele.totalDeductions)),
				(netPay += parseFloat(ele.netPay)),
				ele.paid ? paid++ : paid,
				(totalEntries += 1);
			data.push({
				id: "" + ele.employeeCode,
				firstName: ele.firstName,
				lastName: ele.lastName,
				name: `${ele.firstName} ${ele.lastName}`.toLowerCase(),
				ownerId: ele.owner_id,
				totalGross:
					currencySymbol + parseFloat(ele.grossEarning).toLocaleString(),
				grossNum: ele.grossEarning,
				profile: keywords.daycareProfessional,
				totalDeductions:
					currencySymbol + parseFloat(ele.totalDeductions).toLocaleString(),
				totalDeductionsNum: ele.totalDeductions,
				netPay: currencySymbol + parseFloat(ele.netPay).toLocaleString(),
				netPayNum: ele.netPay,
				status: ele.paid ? "Paid" : "Not Paid",
				basicSalary: ele.basicSalary,
				currency: ele.currency,
				deductions: ele.deductions,
				earning: ele.variableEarning,
				// RM: disabling stripe verification and putting hard code "Verified" status so the code runs well on the payroll. this enables checkbox.
				//verification: ele.stripeConnectedAccountStatus,
				verification: "Verified",
				checked: false,
				issued: false,
			});
		});
		setTotalGrossSum(`${currencySymbol} ${gross.toLocaleString()}`);
		setTotalDeductionSum(`${currencySymbol} ${deductions.toLocaleString()}`);
		setTotalNetSum(`${currencySymbol} ${netPay.toLocaleString()}`);
		setTotalPaid(paid.toLocaleString());
		setTotalEntries(totalEntries.toLocaleString());
		setTotalData(data);
		setFilteredData(data);
		console.log("staff text1", typeof totalPaid, data, response);
	};

	useEffect(() => console.log("payroll", response, isLoading, error), [
		response,
		isLoading,
		error,
	]);

	const sortHandler = (field, value) =>
		setFilteredData((prevData) =>
			[...filteredData].sort((a, b) =>
				value
					? typeof a[field] === "number"
						? a[field] - b[field]
						: a[field].localeCompare(b[field])
					: typeof a[field] === "number"
						? b[field] - a[field]
						: b[field].localeCompare(a[field])
			)
		);
	const directionHandler = (field, index) => {
		let elementData = direction[index];
		const newData = [null, null, null, null, null, null, null, null];
		newData[index] = elementData === null ? false : !elementData;
		sortHandler(field, newData[index]);
		setDirection(() => newData);
	};
	useEffect(
		() =>
			console.log(
				"staff val",
				payResponse.response,
				payResponse.isLoading,
				payResponse.error
			),
		[payResponse.response, payResponse.isLoading, payResponse.error]
	);
	useEffect(() => {
		if (sendEmailResponse.response) {
			setSnackBarContent("email sent");
			snackBarRef.current.openSnackBar();
		}
	}, [sendEmailResponse.response]);

	const paySalaryHandler = () => {
		const data = [];
		let newFilteredData = [...filteredData];
		newFilteredData = newFilteredData.map((ele) => {
			if (ele.checked) {
				data.push(ele.ownerId);
				return { ...ele, status: "Paid", checked: false };
			}
			return ele;
		});
		// Added the snackbar after the salary is paid from the payroll dashboard.
		setSnackBarContent(t("Salary has been paid successfully"));
		snackBarRef.current.openSnackBar();

		setFilteredData(newFilteredData);
		setTotalData(newFilteredData);
		setIsChecked(false);
		setIsDisabled(false);
		console.log("staff val", { month: currentMonth, owners: data });
		setPayBody(JSON.stringify({ month: currentMonth, owners: data }));
	};

	const emailPayHandler = () => {
		const data = [];
		let newFilteredData = [...filteredData];
		newFilteredData = newFilteredData.map((ele) => {
			if (ele.checked) {
				data.push(ele.ownerId);
				return { ...ele, checked: false };
			}
			return ele;
		});
		setFilteredData(newFilteredData);
		setIsChecked(false);
		setIsDisabled(false);
		setEmailBody(JSON.stringify({ month: currentMonth, id: data }));
	};
	const setAllChecked = (checked) => {
		setIsChecked(checked);
		setIsDisabled(checked);
		setFilteredData((prevData) =>
			[...prevData].map((ele) => ({
				...ele,
				checked: ele.verification === "Verified" ? checked : false,
			}))
		);
	};
	useEffect(() => {
		if (downloadPayslipResponse.response) {
			fetch(downloadPayslipResponse.response?.pdf[0], {
				mode: "cors",
			})
				.then((response) => response.blob())
				.then((blob) => {
					let blobUrl = window.URL.createObjectURL(blob);
					console.log("starting download");
					var link = document.createElement("a");
					link.download = `Payslip.pdf`;
					link.href = blobUrl;
					document.body.appendChild(link);
					link.click();
					link.remove();
				})
				.catch((e) => console.error("value error", e));
			setDownloadBody(null);
		}
	}, [downloadPayslipResponse.response]);

	const downloadSlipHandler = () => {
		const data = [];
		let newFilteredData = [...filteredData];
		newFilteredData = newFilteredData.map((ele) => {
			if (ele.checked) {
				data.push(ele.ownerId);
				return { ...ele, checked: false };
			}
			return ele;
		});
		setSnackBarContent(t("Downloading Payslip"));
		snackBarRef.current.openSnackBar();
		setFilteredData(newFilteredData);
		setIsChecked(false);
		setIsDisabled(false);
		setDownloadBody(JSON.stringify({ id: data, month: currentMonth }));
	};
	function exportcsvlist() {
		var csvrow = [];
		var allel = [
			[
				"Employee ID",
				"Last Name",
				"First Name",
				"Profile",
				"Total Gross",
				"TODeduction",
				"Net Pay",
				"Status",
			],
		];
		var temp = filteredData;
		for (var i = 0; i < temp.length; i++) {
			allel.push([
				temp[i].id,
				temp[i].lastName,
				temp[i].firstName,
				temp[i].profile,
				temp[i].totalGross,
				temp[i].totalDeductions,
				temp[i].netPay,
				temp[i].status ? "Paid" : "Not Paid",
			]);
		}
		console.log(allel);
		for (var i = 0; i < allel.length; i++) {
			csvrow.push(allel[i].join(","));
		}
		var csvstring = csvrow.join("%0A");
		console.log("staff csv", csvstring);
		var link = document.createElement("a");
		link.href = "data:attachment/csv," + csvstring;
		link.target = "_blank";
		link.download = "paySlipCSV.csv";
		link.click();
	}
	function exportalldetail() {
		var csvrow = [];
		var allel = [
			[
				"Employee ID",
				"Last Name",
				"First Name",
				"Profile",
				"Basic Salary",
				"Currency",
				"Earning",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				"Deductions",
				,
				,
				,
				,
				,
				,
				,
				,
				,
				"Total deduction",
				"Total Gross earning",
				"Net Pay",
				"Status",
			],
		];
		allel.push([
			,
			,
			,
			,
			,
			,
			"Variable1",
			"Amount1",
			"Variable2",
			"Amount2",
			"Variable3",
			"Amount3",
			"Variable4",
			"Amount4",
			"Variable5",
			"Amount5",
			"Variable1",
			"Amount1",
			"Variable2",
			"Amount2",
			"Variable3",
			"Amount3",
			"Variable4",
			"Amount4",
			"Variable5",
			"amount5",
			,
			,
			,
			,
			,
		]);

		var temp = filteredData;
		for (var i = 0; i < temp.length; i++) {
			let st = "";
			let deduct = [];
			let earning = [];

			for (var j = 0; j < 5; j++) {
				if (temp[i].earning[j]) {
					console.log("1", temp[i].earning[j].variable);
					earning.push([
						temp[i].earning[j].variable,
						temp[i].earning[j].amount,
					]);
				} else {
					console.log("1", temp[i].earning[j]);
					earning.push([, ,]);
				}
			}
			for (var j = 0; j < 5; j++) {
				if (temp[i].deductions[j]) {
					deduct.push([
						temp[i].deductions[j].variable,
						temp[i].deductions[j].amount,
					]);
				} else {
					console.log("1", temp[i].earning[j]);
					deduct.push([, ,]);
				}
			}
			allel.push([
				temp[i].id,
				temp[i].lastName,
				temp[i].firstName,
				temp[i].profile,
				temp[i].basicSalary,
				temp[i].currency,
				earning,
				deduct,
				temp[i].totalGross,
				temp[i].totalDeductions,
				temp[i].netPay,
				temp[i].status ? "Paid" : "Not Paid",
			]);
		}
		console.log(allel);
		for (var i = 0; i < allel.length; i++) {
			csvrow.push(allel[i].join(","));
		}
		var csvstring = csvrow.join("%0A");
		console.log(csvstring);
		var link = document.createElement("a");
		link.href = "data:attachment/csv," + csvstring;
		//link.type = 'MIME'
		link.target = "_blank";
		link.download = "file.csv";

		link.click();
	}

	const [staffId, setStaffId] = useState([]);
	const [showPayment, setShowPayment] = useState(false);
	const [paymentIntentBody, setPaymentIntentBody] = useState(null);
	const [paymentIntent, setPaymentIntent] = useState(null);
	const [multiplePaymentInfo, setMultiplePaymentInfo] = useState([]);
	const [transferPaymentIntent, setTransferPaymentIntent] = useState(null);
	const [transferGroupId, setTransferGroupId] = useState(null);
	const [createTransferBody, setCreateTransferBody] = useState(null);
	const [paymentIntentId, setPaymentIntentId] = useState(null);

	const handleOnlinePayment = () => {
		let multiPaymentArray = [];
		console.log(filteredData);
		setMonth(`${date.split(" ")[1]}, ${date.split(" ")[2]}`);
		let moneyToBePaid = 0;
		let staffCount = 0;
		for (let i = 0; i < filteredData.length; i++) {
			if (
				filteredData[i].status === "Not Paid" &&
				filteredData[i].checked == true
			) {
				const currentMoney = parseFloat(
					filteredData[i].netPay.replace(/\,/g, "").split(" ")[1]
				);
				//console.log({ currentMoney });
				moneyToBePaid += currentMoney;
				console.log(filteredData[i].ownerId);
				setStaffId(filteredData[i].ownerId);
				multiPaymentArray.push({
					daycareProfessionalID: filteredData[i].ownerId,
					amount: (currentMoney * PAYMENT_MULTIPLIER).toString(),
				});
				staffCount = staffCount + 1;
			}
		}
		setMultiplePaymentInfo(multiPaymentArray);
		setPayableAmount(moneyToBePaid);
		setSelectedStaff(staffCount);
		setModalOpen(true);
	};

	const getPaymentIntent = useFetch({
		url: "/createpaymentintent",
		body: paymentIntentBody,
		method: "POST",
		accessibility: accessibilityData["Payroll"],
	});

	const getTransferPaymentIntent = useFetch({
		url: "/createtransferpaymentintent",
		body: transferPaymentIntent,
		method: "POST",
		accessibility: accessibilityData["Payroll"],
	});

	const createTransfer = useFetch({
		url: "/createtransfers",
		method: "POST",
		body: createTransferBody,
		accessibility: accessibilityData["Payroll"],
	});

	useEffect(() => {
		if (getPaymentIntent.response) {
			console.log(getPaymentIntent.response);
			if (getPaymentIntent.response.paymenIntentClientSecret) {
				setPaymentIntent(getPaymentIntent.response.paymentIntentClientSecret);
				setShowPayment(true);
			} else if (getPaymentIntent.response.error) {
				setSnackBarContent(getPaymentIntent.response.error);
				snackBarRef.current.openSnackBar();
			}
		}
	}, [getPaymentIntent.response]);

	const [countryCode, setCountryCode] = useState(null);
	useEffect(() => {
		const body = getTransferPaymentIntent.response;
		if (getTransferPaymentIntent.response) {
			if (body.eligibleForTransfer) {
				setCountryCode(getTransferPaymentIntent.response?.country);
				setPaymentIntent(
					getTransferPaymentIntent.response?.paymentIntentClientSecret
				);
				setTransferGroupId(getTransferPaymentIntent.response?.transferGroup);
				setPaymentIntentId(getTransferPaymentIntent.response?.paymentIntentId);
				setShowPayment(true);
			} else {
				setSnackBarContent(
					t("Some of the accounts are not verified or connected to stripe")
				);
				snackBarRef.current.openSnackBar();
			}
		}
	}, [getTransferPaymentIntent.response]);

	useEffect(() => {
		if (createTransfer.response) {
			const body = createTransfer.response.transfers;
			console.log(createTransfer.response);
			if (body[0].status === "Transfered") {
				paySalaryHandler();
				setModalOpen(true);
				setPaymentSuccess(true);
			}
		}
	}, [createTransfer.response]);

	//handle onclicking the make payment button
	const handlePaymentConfirmationIntent = () => {
		setTransferPaymentIntent(
			JSON.stringify({
				daycareProfessionals: multiplePaymentInfo,
				amount: payableAmount * PAYMENT_MULTIPLIER,
			})
		);

		console.log({ multiplePaymentInfo, payableAmount });
		console.log({ filteredData });
	};

	//!this handles the closing of stripeModal
	const handleStripeToggle = () => {
		setShowPayment(false);
		setPaymentIntentBody(null);
		setTransferPaymentIntent(null);
		setPaymentIntent(null);
	};

	const handleToggle = () => {
		setModalOpen(false);
		if (paymentSuccess) {
			setPaymentIntentBody(null);
			setPayableAmount(0);
			setSelectedStaff(0);
			setPaymentSuccess(false);
		}
	};

	//!this handles the showing payment modal once the payment is done
	const handleOnlinePaymentSucceed = () => {
		console.log("Handle Online Payment Success!");
		setCreateTransferBody(
			JSON.stringify({
				daycareProfessionals: multiplePaymentInfo,
				transferGroup: transferGroupId,
				paymentIntentId: paymentIntentId,
				country: countryCode,
			})
		);
	};

	const selectedRows = filteredData.filter((ele) => ele.checked);
	const canRunSelectionActions =
		selectedRows.length > 0 && accessibilityData["Payroll"] !== "Read";
	const canGeneratePayroll =
		!isLoading &&
		totalPaid == 0 &&
		accessibilityData["Payroll"] !== "Read";
	const currencyLabel =
		typeof currency === "string"
			? currency.split(" ").slice(0, 2).join(" ")
			: currency;

	const renderSortIndicator = (index) => {
		if (direction[index] === null) return null;
		return (
			<ExpandMoreIcon
				className={`${styles.sortIcon} ${
					direction[index] ? styles.sortAscending : ""
				}`}
			/>
		);
	};

	const handleRowSelection = (row, checked) => {
		const newFilteredData = [...filteredData];
		const index = newFilteredData.findIndex((ele) => ele.ownerId === row.ownerId);
		if (index === -1) return;
		newFilteredData[index].checked = checked;
		if (country === "in") {
			for (let i = 0; i < newFilteredData.length; i++) {
				if (i !== index) {
					newFilteredData[i].checked = false;
				}
			}
		}
		setIsDisabled(newFilteredData.findIndex((ele) => ele.checked) !== -1);
		setFilteredData(newFilteredData);
	};

	const payrollColumns = [
		{
			key: "employee",
			label: t("Employee"),
			mobileLabel: t("Employee"),
			onSort: () => directionHandler("id", 0),
			sortIndicator: renderSortIndicator(0),
			render: (row) => (
				<div className={styles.employeeCell}>
					<div className={styles.employeeAvatar}>
						{getInitials(row.firstName, row.lastName)}
					</div>
					<div>
						<strong>{row.firstName} {row.lastName}</strong>
						<span>{t("Employee ID")} {row.id}</span>
					</div>
				</div>
			),
			footer: () => (
				<div className={styles.footerSummary}>
					<strong>{t("Total")}</strong>
					<span>{totalEntries} {t("staff")}</span>
				</div>
			),
		},
		{
			key: "profile",
			label: t("Profile"),
			onSort: () => directionHandler("profile", 3),
			sortIndicator: renderSortIndicator(3),
			render: (row) => <span className={styles.profilePill}>{row.profile}</span>,
		},
		{
			key: "totalGross",
			label: t("Total Gross"),
			align: "right",
			onSort: () => directionHandler("grossNum", 4),
			sortIndicator: renderSortIndicator(4),
			render: (row) => <strong className={styles.amountText}>{row.totalGross}</strong>,
			footer: () => totalGrossSum,
		},
		{
			key: "totalDeductions",
			label: t("Deduction"),
			align: "right",
			onSort: () => directionHandler("totalDeductionsNum", 5),
			sortIndicator: renderSortIndicator(5),
			render: (row) => row.totalDeductions,
			footer: () => totalDeductionSum,
		},
		{
			key: "netPay",
			label: t("Net Pay"),
			align: "right",
			onSort: () => directionHandler("netPayNum", 6),
			sortIndicator: renderSortIndicator(6),
			render: (row) => <strong className={styles.netPayText}>{row.netPay}</strong>,
			footer: () => totalNetSum,
		},
		{
			key: "status",
			label: t("Status"),
			align: "center",
			onSort: () => directionHandler("status", 7),
			sortIndicator: renderSortIndicator(7),
			render: (row) => (
				<span
					className={`${styles.statusChip} ${
						row.status === "Paid" ? styles.paidChip : styles.unpaidChip
					}`}
				>
					{t(row.status)}
				</span>
			),
			footer: () => `${totalPaid}/${totalEntries}`,
		},
		{
			key: "select",
			label: (
				<button
					type="button"
					className={`${styles.checkboxButton} ${
						isChecked ? styles.checkedButton : ""
					}`}
					title={t("Select all")}
					aria-label={t("Select all")}
					aria-pressed={isChecked}
					disabled={
							filteredData.length === 0 ||
							country === "in" ||
							accessibilityData["Payroll"] === "Read"
						}
					onClick={() => setAllChecked(!isChecked)}
				>
					<span />
				</button>
			),
			mobileLabel: "",
			align: "center",
			render: (row) =>
				row.verification === "Verified" ? (
					<button
						type="button"
						className={`${styles.checkboxButton} ${
							row.checked ? styles.checkedButton : ""
						}`}
						aria-label={row.checked ? t("Deselect staff") : t("Select staff")}
						aria-pressed={row.checked}
						disabled={accessibilityData["Payroll"] === "Read"}
						onClick={() => handleRowSelection(row, !row.checked)}
					>
						<span />
					</button>
				) : (
					<MDBPopover placement="top" popover clickable id="popper1">
						<MDBBtn className={classes.button}>
							<InfoIcon color="secondary" />
						</MDBBtn>
						<div>
							<MDBPopoverBody>
								{t(
									"Account details are not verified with Stripe yet, Please check Staff account details."
								)}
							</MDBPopoverBody>
						</div>
					</MDBPopover>
				),
		},
	];

	return (
		<PageShell
			className={styles.payrollPage}
			eyebrow={t("{{professional}} Management", {
				professional: t(keywords.daycareProfessional || "Professional"),
			})}
			title={t("Payroll")}
			description={t("Review salaries, generate payroll and download payslips for the selected month.")}
			actions={
				<button
					type="button"
					className={styles.primaryButton}
					disabled={!canGeneratePayroll}
					onClick={() => {
						console.log(totalData.length);
						console.log(filteredData.length);
						handleGenerateAdHocData();
					}}
				>
					<ReceiptIcon />
					{t("Generate Payroll")}
				</button>
			}
			toolbar={
				<div className={styles.toolbar}>
					<div className={styles.searchBox}>
						<SearchIcon />
						<input
							type="search"
							placeholder={t("Search by {{label}} name", {
								label: t(keywords.daycareProfessional || "Professional").toLowerCase(),
							})}
							onChange={(event) =>
								searchTextHandler(event.target.value.toLowerCase())
							}
						/>
					</div>
					<div className={styles.monthControl} aria-label={t("Payroll month")}>
						<button type="button" onClick={() => changeDate(-1)}>
							<ChevronLeftIcon />
						</button>
						<div>
							<span>{t("Month")}</span>
							<strong>{currentMonth}</strong>
						</div>
						<button type="button" onClick={() => changeDate(1)}>
							<ChevronRightIcon />
						</button>
					</div>
					<div className={styles.currencyPill}>
						<span>{t("Currency")}</span>
						<strong>{currencyLabel}</strong>
					</div>
				</div>
			}
		>
			<SnackBar ref={snackBarRef} content={snackBarContent} />
			{showPayment && (
				<CardStripe
					isOpen={showPayment}
					paymentIntent={paymentIntent}
					countryCode={countryCode}
					toggle={handleStripeToggle}
					onSuccess={handleOnlinePaymentSucceed}
				/>
			)}
			{modalOpen && (
				<PaymentConfirmationModal
					paymentSuccess={paymentSuccess}
					paymentConfirmationIntent={() => {
						handlePaymentConfirmationIntent();
					}}
					month={month}
					isOpen={modalOpen}
					payableAmount={payableAmount}
					selectedStaff={selectedStaff}
					handleToggle={handleToggle}
				/>
			)}

			<div className={styles.summaryGrid}>
				<div className={styles.summaryCard}>
					<div className={styles.summaryIcon}>
						<PeopleIcon />
					</div>
					<div>
						<span>{t("Staff")}</span>
						<strong>{totalEntries || 0}</strong>
					</div>
				</div>
				<div className={styles.summaryCard}>
					<div className={styles.summaryIcon}>
						<TrendingUpIcon />
					</div>
					<div>
						<span>{t("Total Gross")}</span>
						<strong>{totalGrossSum || `${currency[0]} 0`}</strong>
					</div>
				</div>
				<div className={styles.summaryCard}>
					<div className={styles.summaryIcon}>
						<RemoveCircleOutlineIcon />
					</div>
					<div>
						<span>{t("Deduction")}</span>
						<strong>{totalDeductionSum || `${currency[0]} 0`}</strong>
					</div>
				</div>
				<div className={styles.summaryCard}>
					<div className={styles.summaryIcon}>
						<CheckCircleIcon />
					</div>
					<div>
						<span>{t("Paid")}</span>
						<strong>{totalPaid || 0}/{totalEntries || 0}</strong>
					</div>
				</div>
			</div>

			<div className={styles.tableActions}>
				<div className={styles.selectionSummary}>
					<strong>{selectedRows.length}</strong>
					<span>{t("selected")}</span>
				</div>
				<div className={styles.actionGroup}>
					<button
						type="button"
						className={styles.actionButton}
						disabled={!canRunSelectionActions}
						onClick={paySalaryHandler}
					>
						<AccountBalanceWalletIcon />
						{t("Pay")}
					</button>
					<button
						type="button"
						className={styles.secondaryButton}
						disabled={error || !canRunSelectionActions}
						onClick={downloadSlipHandler}
					>
						<FileDownloadIcon />
						{t("Download Payslip")}
					</button>
				</div>
			</div>

			{isLoading || getPayRoll.isLoading ? (
				<div className={styles.loaderWrap}>
					<Loader />
				</div>
			) : error ? (
				<EmptyState
					title={t("No Data Available for this month")}
					description={t("Generate payroll for the selected month to prepare staff salary records.")}
					action={
						<button
							type="button"
							className={styles.primaryButton}
							disabled={accessibilityData["Payroll"] === "Read"}
							onClick={handleGenerateAdHocData}
						>
							<ReceiptIcon />
							{t("Generate Payroll")}
						</button>
					}
				/>
			) : !totalData.length ? (
				<div className={styles.loaderWrap}>
					<Loader />
				</div>
			) : (
				<DataTable
					columns={payrollColumns}
					data={filteredData}
					getRowKey={(row) => row.ownerId || row.id}
					footerData={{}}
					emphasizeFooter
					emptyMessage={t("No payroll records match the current search")}
					className={styles.payrollTable}
				/>
			)}
		</PageShell>
	);
};

export default PayRoll;
